// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://api.short.io' | (string & {});
};

export type GetLinkOpengraphData = {
    body?: never;
    path: {
        domainId: number;
        linkId: string;
    };
    query?: never;
    url: '/links/opengraph/{domainId}/{linkId}';
};

export type GetLinkOpengraphResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type UpdateLinkOpengraphData = {
    body?: Array<[
        'title' | 'type' | 'image' | 'url' | 'audio' | 'description' | 'determiner' | 'locale' | 'locale:alternate' | 'site_name' | 'video' | 'article:published_time' | 'article:modified_time' | 'article:expiration_time' | 'article:author' | 'article:section' | 'article:tag' | 'updated_time' | 'image:url' | 'image:secure_url' | 'image:type' | 'image:width' | 'image:height' | 'image:alt' | 'music:duration' | 'music:album' | 'music:album:disc' | 'music:album:track' | 'music:musician' | 'music:song' | 'music:song:disc' | 'music:song:track' | 'music:release_date' | 'music:creator' | 'video:actor' | 'video:actor:role' | 'video:director' | 'video:writer' | 'video:duration' | 'video:release_date' | 'video:tag' | 'video:series' | 'book:author' | 'book:isbn' | 'book:release_date' | 'book:tag' | 'product:price:amount' | 'product:price:currency' | 'product:availability' | 'product:condition' | 'product:retailer_item_id' | 'product:brand' | 'product:category' | 'product:color' | 'product:size' | 'product:material' | 'product:pattern' | 'product:shipping_cost:amount' | 'product:shipping_cost:currency' | 'product:shipping_weight:value' | 'product:shipping_weight:units' | 'product:weight:value' | 'product:weight:units' | 'product:sale_price:amount' | 'product:sale_price:currency' | 'product:sale_price_dates:start' | 'product:sale_price_dates:end' | 'product:expiration_time' | 'product:original_price:amount' | 'product:original_price:currency' | 'product:gender' | 'product:age_group' | 'product:target_gender' | 'product:retailer_part_no' | 'product:mfr_part_no' | 'product:upc' | 'product:ean' | 'product:isbn' | 'product:plural_title' | 'product:item_group_id' | 'profile:first_name' | 'profile:last_name' | 'profile:username' | 'profile:gender' | 'twitter:card' | 'twitter:site' | 'twitter:site:id' | 'twitter:creator' | 'twitter:creator:id' | 'twitter:description' | 'twitter:title' | 'twitter:image' | 'twitter:image:alt' | 'twitter:player' | 'twitter:player:width' | 'twitter:player:height' | 'twitter:player:stream' | 'twitter:app:name:iphone' | 'twitter:app:id:iphone' | 'twitter:app:url:iphone' | 'twitter:app:name:ipad' | 'twitter:app:id:ipad' | 'twitter:app:url:ipad' | 'twitter:app:name:googleplay' | 'twitter:app:id:googleplay' | 'twitter:app:url:googleplay' | 'twitter:app:country',
        string
    ]>;
    path: {
        domainId: number;
        linkId: string;
    };
    query?: never;
    url: '/links/opengraph/{domainId}/{linkId}';
};

export type UpdateLinkOpengraphResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GetLinkCountriesData = {
    body?: never;
    path: {
        linkId: string;
    };
    query?: {
        domainId?: string;
    };
    url: '/link_country/{linkId}';
};

export type GetLinkCountriesResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateLinkCountryData = {
    body: {
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
        originalURL: string;
    };
    path: {
        linkId: string;
    };
    query?: {
        domainId?: string;
    };
    url: '/link_country/{linkId}';
};

export type CreateLinkCountryResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateLinkCountriesBulkData = {
    body?: Array<{
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
        originalURL: string;
    }>;
    path: {
        linkId: string;
    };
    query?: {
        domainId?: string;
    };
    url: '/link_country/bulk/{linkId}';
};

export type CreateLinkCountriesBulkResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type DeleteLinkCountryData = {
    body?: never;
    path: {
        linkId: string;
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
    };
    query?: {
        domainId?: string;
    };
    url: '/link_country/{linkId}/{country}';
};

export type DeleteLinkCountryResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GetLinkRegionsData = {
    body?: never;
    path: {
        linkId: string;
    };
    query?: {
        domainId?: string;
    };
    url: '/link_region/{linkId}';
};

export type GetLinkRegionsResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateLinkRegionData = {
    body: {
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
        /**
         * ISO 3166-2 region code
         */
        region: string;
        originalURL: string;
    };
    path: {
        linkId: string;
    };
    query?: {
        /**
         * Domain ID
         */
        domainId?: number;
    };
    url: '/link_region/{linkId}';
};

export type CreateLinkRegionResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GetRegionsByCountryData = {
    body?: never;
    path: {
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
    };
    query?: never;
    url: '/link_region/list/{country}';
};

export type GetRegionsByCountryResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateLinkRegionsBulkData = {
    body?: Array<{
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
        /**
         * ISO 3166-2 region code
         */
        region: string;
        originalURL: string;
    }>;
    path: {
        linkId: string;
    };
    query?: {
        domainId?: number;
    };
    url: '/link_region/bulk/{linkId}';
};

export type CreateLinkRegionsBulkResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type DeleteLinkRegionData = {
    body?: never;
    path: {
        linkId: string;
        /**
         * Country code
         */
        country: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW' | 'EU' | 'QF' | 'QS' | 'QE' | 'QO' | 'QN' | 'QT' | 'XK';
        region: string;
    };
    query?: {
        domainId?: string;
    };
    url: '/link_region/{linkId}/{country}/{region}';
};

export type DeleteLinkRegionResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GetLinkPermissionsData = {
    body?: never;
    path: {
        domainId: string;
        linkId: string;
    };
    query?: never;
    url: '/links/permissions/{domainId}/{linkId}';
};

export type GetLinkPermissionsErrors = {
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type GetLinkPermissionsError = GetLinkPermissionsErrors[keyof GetLinkPermissionsErrors];

export type GetLinkPermissionsResponses = {
    /**
     * Default Response
     */
    200: Array<{
        id: string;
        DomainId: number;
        UserId: number;
        LinkIdString: string;
    }>;
};

export type GetLinkPermissionsResponse = GetLinkPermissionsResponses[keyof GetLinkPermissionsResponses];

export type DeleteLinkPermissionData = {
    body?: never;
    path: {
        domainId: number;
        linkId: string;
        userId: string;
    };
    query?: never;
    url: '/links/permissions/{domainId}/{linkId}/{userId}';
};

export type DeleteLinkPermissionErrors = {
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type DeleteLinkPermissionError = DeleteLinkPermissionErrors[keyof DeleteLinkPermissionErrors];

export type DeleteLinkPermissionResponses = {
    /**
     * Default Response
     */
    201: {
        success: boolean;
    };
};

export type DeleteLinkPermissionResponse = DeleteLinkPermissionResponses[keyof DeleteLinkPermissionResponses];

export type AddLinkPermissionData = {
    body?: never;
    path: {
        domainId: string;
        /**
         * Link ID
         */
        linkId: string;
        userId: string;
    };
    query?: never;
    url: '/links/permissions/{domainId}/{linkId}/{userId}';
};

export type AddLinkPermissionErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type AddLinkPermissionError = AddLinkPermissionErrors[keyof AddLinkPermissionErrors];

export type AddLinkPermissionResponses = {
    /**
     * Default Response
     */
    201: {
        id: string;
        DomainId: number;
        UserId: number;
        /**
         * Link ID
         */
        LinkIdString: string;
    };
};

export type AddLinkPermissionResponse = AddLinkPermissionResponses[keyof AddLinkPermissionResponses];

export type ListLinksData = {
    body?: never;
    headers?: {
        'x-vercel-id'?: string;
    };
    path?: never;
    query: {
        /**
         * Domain ID
         */
        domain_id: number;
        limit?: number;
        idString?: string;
        createdAt?: string;
        beforeDate?: string;
        afterDate?: string;
        dateSortOrder?: 'asc' | 'desc';
        pageToken?: string;
        folderId?: string;
    };
    url: '/api/links';
};

export type ListLinksErrors = {
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type ListLinksError = ListLinksErrors[keyof ListLinksErrors];

export type ListLinksResponses = {
    /**
     * Default Response
     */
    200: {
        count: number;
        links: Array<{
            /**
             * Original URL
             */
            originalURL: string;
            /**
             * Cloaking
             */
            cloaking?: boolean;
            /**
             * Link password
             */
            password?: string;
            /**
             * Link expiration date in milliseconds or ISO string
             */
            expiresAt?: number | string;
            /**
             * Expired URL
             */
            expiredURL?: string;
            /**
             * Link title
             */
            title?: string;
            /**
             * Array of link tags
             */
            tags?: Array<string>;
            /**
             * set utm_source parameter to destination link
             */
            utmSource?: string;
            /**
             * set utm_medium parameter to destination link
             */
            utmMedium?: string;
            /**
             * set utm_campaign parameter to destination link
             */
            utmCampaign?: string;
            /**
             * set utm_term parameter to destination link
             */
            utmTerm?: string;
            /**
             * set utm_content parameter to destination link
             */
            utmContent?: string;
            /**
             * Time to live in milliseconds or ISO string
             */
            ttl?: string | number;
            /**
             * Link slug
             */
            path?: string;
            /**
             * Android URL
             */
            androidURL?: string;
            /**
             * iPhone URL
             */
            iphoneURL?: string;
            /**
             * Link creation date in milliseconds
             */
            createdAt?: number | string;
            /**
             * disable link after specified number of clicks
             */
            clicksLimit?: number;
            /**
             * Provide your email to users to get a password
             */
            passwordContact?: boolean;
            /**
             * Skip query string merging
             */
            skipQS?: boolean;
            /**
             * Link is archived
             */
            archived?: boolean;
            /**
             * Split URL
             */
            splitURL?: string;
            /**
             * Split URL percentage
             */
            splitPercent?: number;
            /**
             * Adroll integration
             */
            integrationAdroll?: string;
            /**
             * Facebook integration
             */
            integrationFB?: string;
            /**
             * TikTok integration
             */
            integrationTT?: string;
            /**
             * Google Analytics integration
             */
            integrationGA?: string;
            /**
             * Google Tag Manager integration
             */
            integrationGTM?: string;
        } & {
            /**
             * Link ID
             */
            idString: string;
            /**
             * Link ID
             */
            id: string;
            /**
             * Short URL
             */
            shortURL: string;
            /**
             * Secure short URL
             */
            secureShortURL: string;
            /**
             * Link slug
             */
            path: string;
            /**
             * HTTP code for redirect
             */
            redirectType?: '301' | '302' | '307' | '308';
            /**
             * Folder ID
             */
            FolderId?: string;
            /**
             * Domain ID
             */
            DomainId?: number;
            /**
             * Owner ID
             */
            OwnerId?: number;
            /**
             * Link has password
             */
            hasPassword?: boolean;
            /**
             * Link source
             */
            source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
            User?: {
                /**
                 * Creator user ID
                 */
                id: number;
                /**
                 * Creator name
                 */
                name: string;
                /**
                 * Creator email
                 */
                email: string;
                /**
                 * User photo URL
                 */
                photoURL: string;
            };
        }>;
        nextPageToken?: string;
    };
};

export type ListLinksResponse = ListLinksResponses[keyof ListLinksResponses];

export type GenerateQrCodeData = {
    body: {
        color?: string;
        backgroundColor?: string;
        size?: number;
        type?: 'png' | 'svg';
        useDomainSettings: boolean;
    };
    headers?: {
        accept?: string;
    };
    path: {
        /**
         * Link ID
         */
        linkIdString: string;
    };
    query?: never;
    url: '/links/qr/{linkIdString}';
};

export type GenerateQrCodeResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GenerateQrCodesBulkData = {
    body: {
        color?: string;
        backgroundColor?: string;
        size?: number;
        type: 'png' | 'svg';
        useDomainSettings: boolean;
        noExcavate?: boolean;
        linkIds: Array<string>;
        domainId?: string;
    };
    path?: never;
    query?: never;
    url: '/links/qr/bulk';
};

export type GenerateQrCodesBulkResponses = {
    /**
     * ZIP file containing QR codes
     */
    201: unknown;
};

export type DeleteLinkData = {
    body?: never;
    path: {
        /**
         * Link ID
         */
        link_id: string;
    };
    query?: never;
    url: '/links/{link_id}';
};

export type DeleteLinkErrors = {
    /**
     * Default Response
     */
    400: {
        success: boolean;
        error: string;
    };
    /**
     * Default Response
     */
    401: {
        success: boolean;
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        success: boolean;
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        success: boolean;
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        success: boolean;
        error: string;
    };
    /**
     * Default Response
     */
    409: {
        success: boolean;
        error: string;
    };
    /**
     * Default Response
     */
    500: {
        success: boolean;
        error: string;
    };
};

export type DeleteLinkError = DeleteLinkErrors[keyof DeleteLinkErrors];

export type DeleteLinkResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        /**
         * Link ID
         */
        idString?: string;
        error?: string;
    };
};

export type DeleteLinkResponse = DeleteLinkResponses[keyof DeleteLinkResponses];

export type DeleteLinksBulkData = {
    body: {
        link_ids: Array<string>;
    };
    path?: never;
    query?: never;
    url: '/links/delete_bulk';
};

export type DeleteLinksBulkResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        error?: string;
    };
};

export type DeleteLinksBulkResponse = DeleteLinksBulkResponses[keyof DeleteLinksBulkResponses];

export type ArchiveLinkData = {
    body: {
        link_id: string;
        domain_id?: string;
    };
    path?: never;
    query?: never;
    url: '/links/archive';
};

export type ArchiveLinkErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    401: {
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
    /**
     * Default Response
     */
    409: {
        error: string;
    };
    /**
     * Default Response
     */
    500: {
        error: string;
    };
};

export type ArchiveLinkError = ArchiveLinkErrors[keyof ArchiveLinkErrors];

export type ArchiveLinkResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        error?: string;
    };
};

export type ArchiveLinkResponse = ArchiveLinkResponses[keyof ArchiveLinkResponses];

export type ArchiveLinksBulkData = {
    body: {
        link_ids: Array<string>;
        domain_id?: string;
    };
    path?: never;
    query?: never;
    url: '/links/archive_bulk';
};

export type ArchiveLinksBulkErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    401: {
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    409: {
        error: string;
    };
    /**
     * Default Response
     */
    500: {
        error: string;
        message?: string;
    };
};

export type ArchiveLinksBulkError = ArchiveLinksBulkErrors[keyof ArchiveLinksBulkErrors];

export type ArchiveLinksBulkResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        error?: string;
    };
};

export type ArchiveLinksBulkResponse = ArchiveLinksBulkResponses[keyof ArchiveLinksBulkResponses];

export type UnarchiveLinkData = {
    body: {
        link_id: string;
        domain_id?: string;
    };
    path?: never;
    query?: never;
    url: '/links/unarchive';
};

export type UnarchiveLinkErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    401: {
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    409: {
        error: string;
    };
    /**
     * Default Response
     */
    500: {
        error: string;
    };
};

export type UnarchiveLinkError = UnarchiveLinkErrors[keyof UnarchiveLinkErrors];

export type UnarchiveLinkResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        error?: string;
    };
};

export type UnarchiveLinkResponse = UnarchiveLinkResponses[keyof UnarchiveLinkResponses];

export type UnarchiveLinksBulkData = {
    body: {
        link_ids: Array<string>;
        domain_id?: string;
    };
    path?: never;
    query?: never;
    url: '/links/unarchive_bulk';
};

export type UnarchiveLinksBulkErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    401: {
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
    /**
     * Default Response
     */
    409: {
        error: string;
    };
    /**
     * Default Response
     */
    500: {
        error: string;
    };
};

export type UnarchiveLinksBulkError = UnarchiveLinksBulkErrors[keyof UnarchiveLinksBulkErrors];

export type UnarchiveLinksBulkResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        error?: string;
    };
};

export type UnarchiveLinksBulkResponse = UnarchiveLinksBulkResponses[keyof UnarchiveLinksBulkResponses];

export type GetLinkData = {
    body?: never;
    path: {
        linkId: string;
    };
    query?: {
        /**
         * [DEPRECATED] Domain ID
         */
        domainId?: string;
    };
    url: '/links/{linkId}';
};

export type GetLinkErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type GetLinkError = GetLinkErrors[keyof GetLinkErrors];

export type GetLinkResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Link ID
         */
        idString: string;
        /**
         * Link ID
         */
        id: string;
        /**
         * Short URL
         */
        shortURL: string;
        /**
         * Secure short URL
         */
        secureShortURL: string;
        /**
         * Link slug
         */
        path: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: '301' | '302' | '307' | '308';
        /**
         * Folder ID
         */
        FolderId?: string;
        /**
         * Domain ID
         */
        DomainId?: number;
        /**
         * Owner ID
         */
        OwnerId?: number;
        /**
         * Link has password
         */
        hasPassword?: boolean;
        /**
         * Link source
         */
        source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
        User?: {
            /**
             * Creator user ID
             */
            id: number;
            /**
             * Creator name
             */
            name: string;
            /**
             * Creator email
             */
            email: string;
            /**
             * User photo URL
             */
            photoURL: string;
        };
    };
};

export type GetLinkResponse = GetLinkResponses[keyof GetLinkResponses];

export type UpdateLinkData = {
    body?: {
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: 301 | 302 | 307 | 308;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
        /**
         * Original URL
         */
        originalURL?: string;
    };
    path: {
        linkId: string;
    };
    query?: {
        domain_id?: string;
    };
    url: '/links/{linkId}';
};

export type UpdateLinkErrors = {
    /**
     * Default Response
     */
    400: {
        message: string;
        field?: string;
        linkId?: string;
    };
    /**
     * Default Response
     */
    401: {
        message: string;
        field?: string;
        linkId?: string;
    };
    /**
     * Default Response
     */
    402: {
        message: string;
        field?: string;
        linkId?: string;
    };
    /**
     * Default Response
     */
    403: {
        message: string;
    };
    /**
     * Default Response
     */
    404: {
        message: string;
    };
    /**
     * Default Response
     */
    409: {
        message: string;
        field?: string;
        linkId?: string;
    };
    /**
     * Default Response
     */
    500: {
        message: string;
    };
};

export type UpdateLinkError = UpdateLinkErrors[keyof UpdateLinkErrors];

export type UpdateLinkResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Link ID
         */
        idString: string;
        /**
         * Link ID
         */
        id: string;
        /**
         * Short URL
         */
        shortURL: string;
        /**
         * Secure short URL
         */
        secureShortURL: string;
        /**
         * Link slug
         */
        path: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: '301' | '302' | '307' | '308';
        /**
         * Folder ID
         */
        FolderId?: string;
        /**
         * Domain ID
         */
        DomainId?: number;
        /**
         * Owner ID
         */
        OwnerId?: number;
        /**
         * Link has password
         */
        hasPassword?: boolean;
        /**
         * Link source
         */
        source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
        User?: {
            /**
             * Creator user ID
             */
            id: number;
            /**
             * Creator name
             */
            name: string;
            /**
             * Creator email
             */
            email: string;
            /**
             * User photo URL
             */
            photoURL: string;
        };
    };
};

export type UpdateLinkResponse = UpdateLinkResponses[keyof UpdateLinkResponses];

export type ExpandLinkData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Domain hostname
         */
        domain: string;
        /**
         * Link path
         */
        path: string;
    };
    url: '/links/expand';
};

export type ExpandLinkErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type ExpandLinkError = ExpandLinkErrors[keyof ExpandLinkErrors];

export type ExpandLinkResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Link ID
         */
        idString: string;
        /**
         * Link ID
         */
        id: string;
        /**
         * Short URL
         */
        shortURL: string;
        /**
         * Secure short URL
         */
        secureShortURL: string;
        /**
         * Link slug
         */
        path: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: '301' | '302' | '307' | '308';
        /**
         * Folder ID
         */
        FolderId?: string;
        /**
         * Domain ID
         */
        DomainId?: number;
        /**
         * Owner ID
         */
        OwnerId?: number;
        /**
         * Link has password
         */
        hasPassword?: boolean;
        /**
         * Link source
         */
        source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
        User?: {
            /**
             * Creator user ID
             */
            id: number;
            /**
             * Creator name
             */
            name: string;
            /**
             * Creator email
             */
            email: string;
            /**
             * User photo URL
             */
            photoURL: string;
        };
    };
};

export type ExpandLinkResponse = ExpandLinkResponses[keyof ExpandLinkResponses];

export type GetLinkByOriginalUrlData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Domain hostname
         */
        domain: string;
        /**
         * Link original URL
         */
        originalURL: string;
    };
    url: '/links/by-original-url';
};

export type GetLinkByOriginalUrlResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GetLinksByUrlData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Domain hostname
         */
        domain: string;
        /**
         * Link original URL
         */
        originalURL: string;
    };
    url: '/links/multiple-by-url';
};

export type GetLinksByUrlResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateLinkData = {
    body?: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: 301 | 302 | 307 | 308;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Domain hostname
         */
        domain: string;
        /**
         * Allow duplicates
         */
        allowDuplicates?: boolean;
        /**
         * Folder ID
         */
        folderId?: string;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
    };
    path?: never;
    query?: never;
    url: '/links';
};

export type CreateLinkErrors = {
    /**
     * Default Response
     */
    400: {
        code?: string;
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    401: {
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    402: {
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    403: {
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    404: {
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    409: {
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    500: {
        message: string;
        success?: boolean;
        statusCode: number;
    };
};

export type CreateLinkError = CreateLinkErrors[keyof CreateLinkErrors];

export type CreateLinkResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Link ID
         */
        idString: string;
        /**
         * Link ID
         */
        id: string;
        /**
         * Short URL
         */
        shortURL: string;
        /**
         * Secure short URL
         */
        secureShortURL: string;
        /**
         * Link slug
         */
        path: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: '301' | '302' | '307' | '308';
        /**
         * Folder ID
         */
        FolderId?: string;
        /**
         * Domain ID
         */
        DomainId?: number;
        /**
         * Owner ID
         */
        OwnerId?: number;
        /**
         * Link has password
         */
        hasPassword?: boolean;
        /**
         * Link source
         */
        source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
        User?: {
            /**
             * Creator user ID
             */
            id: number;
            /**
             * Creator name
             */
            name: string;
            /**
             * Creator email
             */
            email: string;
            /**
             * User photo URL
             */
            photoURL: string;
        };
    } & {
        success?: boolean;
        duplicate?: boolean;
    };
};

export type CreateLinkResponse = CreateLinkResponses[keyof CreateLinkResponses];

export type CreateLinkSimpleData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Domain hostname
         */
        domain: string;
        /**
         * Link path
         */
        path?: string;
        /**
         * Link original URL
         */
        originalURL: string;
        /**
         * Link title
         */
        title?: string;
        urlOnly?: '1' | '0' | boolean;
        /**
         * API key
         */
        apiKey: string;
    };
    url: '/links/tweetbot';
};

export type CreateLinkSimpleResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateLinkPublicData = {
    body: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: 301 | 302 | 307 | 308;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
        domain: string;
        folderId?: string;
    };
    headers?: {
        type?: unknown;
        additionalProperties?: string;
    };
    path?: never;
    query?: never;
    url: '/links/public';
};

export type CreateLinkPublicErrors = {
    /**
     * Default Response
     */
    400: {
        code?: string;
        message: string;
        success?: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    401: {
        message: string;
        success: boolean;
        statusCode: number;
    };
    /**
     * Default Response
     */
    402: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    403: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    404: {
        message: string;
        success: boolean;
    };
    /**
     * Default Response
     */
    409: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    500: {
        message: string;
        success: boolean;
    };
};

export type CreateLinkPublicError = CreateLinkPublicErrors[keyof CreateLinkPublicErrors];

export type CreateLinkPublicResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Link ID
         */
        idString: string;
        /**
         * Link ID
         */
        id: string;
        /**
         * Short URL
         */
        shortURL: string;
        /**
         * Secure short URL
         */
        secureShortURL: string;
        /**
         * Link slug
         */
        path: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: '301' | '302' | '307' | '308';
        /**
         * Folder ID
         */
        FolderId?: string;
        /**
         * Domain ID
         */
        DomainId?: number;
        /**
         * Owner ID
         */
        OwnerId?: number;
        /**
         * Link has password
         */
        hasPassword?: boolean;
        /**
         * Link source
         */
        source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
        User?: {
            /**
             * Creator user ID
             */
            id: number;
            /**
             * Creator name
             */
            name: string;
            /**
             * Creator email
             */
            email: string;
            /**
             * User photo URL
             */
            photoURL: string;
        };
    } & {
        success?: boolean;
        duplicate?: boolean;
    };
};

export type CreateLinkPublicResponse = CreateLinkPublicResponses[keyof CreateLinkPublicResponses];

export type CreateLinksBulkData = {
    body: {
        domain: string;
        allowDuplicates?: boolean;
        links: Array<{
            allowDuplicates?: boolean;
        } & {
            /**
             * Original URL
             */
            originalURL: string;
            /**
             * Cloaking
             */
            cloaking?: boolean;
            /**
             * Link password
             */
            password?: string;
            /**
             * HTTP code for redirect
             */
            redirectType?: 301 | 302 | 307 | 308;
            /**
             * Link expiration date in milliseconds or ISO string
             */
            expiresAt?: number | string;
            /**
             * Expired URL
             */
            expiredURL?: string;
            /**
             * Link title
             */
            title?: string;
            /**
             * Array of link tags
             */
            tags?: Array<string>;
            /**
             * set utm_source parameter to destination link
             */
            utmSource?: string;
            /**
             * set utm_medium parameter to destination link
             */
            utmMedium?: string;
            /**
             * set utm_campaign parameter to destination link
             */
            utmCampaign?: string;
            /**
             * set utm_term parameter to destination link
             */
            utmTerm?: string;
            /**
             * set utm_content parameter to destination link
             */
            utmContent?: string;
            /**
             * Time to live in milliseconds or ISO string
             */
            ttl?: string | number;
            /**
             * Link slug
             */
            path?: string;
            /**
             * Android URL
             */
            androidURL?: string;
            /**
             * iPhone URL
             */
            iphoneURL?: string;
            /**
             * Link creation date in milliseconds
             */
            createdAt?: number | string;
            /**
             * disable link after specified number of clicks
             */
            clicksLimit?: number;
            /**
             * Provide your email to users to get a password
             */
            passwordContact?: boolean;
            /**
             * Skip query string merging
             */
            skipQS?: boolean;
            /**
             * Link is archived
             */
            archived?: boolean;
            /**
             * Split URL
             */
            splitURL?: string;
            /**
             * Split URL percentage
             */
            splitPercent?: number;
            /**
             * Adroll integration
             */
            integrationAdroll?: string;
            /**
             * Facebook integration
             */
            integrationFB?: string;
            /**
             * TikTok integration
             */
            integrationTT?: string;
            /**
             * Google Analytics integration
             */
            integrationGA?: string;
            /**
             * Google Tag Manager integration
             */
            integrationGTM?: string;
        }>;
        /**
         * Folder ID
         */
        folderId?: string;
    };
    path?: never;
    query?: never;
    url: '/links/bulk';
};

export type CreateLinksBulkResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateExampleLinksData = {
    body: {
        /**
         * Domain hostname to create examples for
         */
        domain: string;
    };
    path?: never;
    query?: never;
    url: '/links/examples';
};

export type CreateExampleLinksErrors = {
    /**
     * Default Response
     */
    400: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    401: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    402: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    403: {
        message: string;
    };
    /**
     * Default Response
     */
    404: {
        message: string;
    };
    /**
     * Default Response
     */
    409: {
        message: string;
        success?: boolean;
    };
    /**
     * Default Response
     */
    500: {
        message: string;
        success?: boolean;
    };
};

export type CreateExampleLinksError = CreateExampleLinksErrors[keyof CreateExampleLinksErrors];

export type CreateExampleLinksResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
        links: Array<{
            /**
             * Original URL
             */
            originalURL: string;
            /**
             * Cloaking
             */
            cloaking?: boolean;
            /**
             * Link password
             */
            password?: string;
            /**
             * Link expiration date in milliseconds or ISO string
             */
            expiresAt?: number | string;
            /**
             * Expired URL
             */
            expiredURL?: string;
            /**
             * Link title
             */
            title?: string;
            /**
             * Array of link tags
             */
            tags?: Array<string>;
            /**
             * set utm_source parameter to destination link
             */
            utmSource?: string;
            /**
             * set utm_medium parameter to destination link
             */
            utmMedium?: string;
            /**
             * set utm_campaign parameter to destination link
             */
            utmCampaign?: string;
            /**
             * set utm_term parameter to destination link
             */
            utmTerm?: string;
            /**
             * set utm_content parameter to destination link
             */
            utmContent?: string;
            /**
             * Time to live in milliseconds or ISO string
             */
            ttl?: string | number;
            /**
             * Link slug
             */
            path?: string;
            /**
             * Android URL
             */
            androidURL?: string;
            /**
             * iPhone URL
             */
            iphoneURL?: string;
            /**
             * Link creation date in milliseconds
             */
            createdAt?: number | string;
            /**
             * disable link after specified number of clicks
             */
            clicksLimit?: number;
            /**
             * Provide your email to users to get a password
             */
            passwordContact?: boolean;
            /**
             * Skip query string merging
             */
            skipQS?: boolean;
            /**
             * Link is archived
             */
            archived?: boolean;
            /**
             * Split URL
             */
            splitURL?: string;
            /**
             * Split URL percentage
             */
            splitPercent?: number;
            /**
             * Adroll integration
             */
            integrationAdroll?: string;
            /**
             * Facebook integration
             */
            integrationFB?: string;
            /**
             * TikTok integration
             */
            integrationTT?: string;
            /**
             * Google Analytics integration
             */
            integrationGA?: string;
            /**
             * Google Tag Manager integration
             */
            integrationGTM?: string;
        } & {
            /**
             * Link ID
             */
            idString: string;
            /**
             * Link ID
             */
            id: string;
            /**
             * Short URL
             */
            shortURL: string;
            /**
             * Secure short URL
             */
            secureShortURL: string;
            /**
             * Link slug
             */
            path: string;
            /**
             * HTTP code for redirect
             */
            redirectType?: '301' | '302' | '307' | '308';
            /**
             * Folder ID
             */
            FolderId?: string;
            /**
             * Domain ID
             */
            DomainId?: number;
            /**
             * Owner ID
             */
            OwnerId?: number;
            /**
             * Link has password
             */
            hasPassword?: boolean;
            /**
             * Link source
             */
            source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
            User?: {
                /**
                 * Creator user ID
                 */
                id: number;
                /**
                 * Creator name
                 */
                name: string;
                /**
                 * Creator email
                 */
                email: string;
                /**
                 * User photo URL
                 */
                photoURL: string;
            };
        } & {
            success?: boolean;
            duplicate?: boolean;
        }>;
    };
};

export type CreateExampleLinksResponse = CreateExampleLinksResponses[keyof CreateExampleLinksResponses];

export type DuplicateLinkData = {
    body?: {
        /**
         * Custom path for duplicated link
         */
        path?: string;
    };
    path: {
        linkId: string;
    };
    query?: never;
    url: '/links/duplicate/{linkId}';
};

export type DuplicateLinkErrors = {
    /**
     * Default Response
     */
    400: {
        message: string;
        field?: string;
    };
    /**
     * Default Response
     */
    401: {
        message: string;
    };
    /**
     * Default Response
     */
    402: {
        message: string;
        field?: string;
    };
    /**
     * Default Response
     */
    403: {
        message: string;
    };
    /**
     * Default Response
     */
    404: {
        message: string;
    };
    /**
     * Default Response
     */
    409: {
        message: string;
        field?: string;
    };
    /**
     * Default Response
     */
    500: {
        message: string;
    };
};

export type DuplicateLinkError = DuplicateLinkErrors[keyof DuplicateLinkErrors];

export type DuplicateLinkResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Original URL
         */
        originalURL: string;
        /**
         * Cloaking
         */
        cloaking?: boolean;
        /**
         * Link password
         */
        password?: string;
        /**
         * Link expiration date in milliseconds or ISO string
         */
        expiresAt?: number | string;
        /**
         * Expired URL
         */
        expiredURL?: string;
        /**
         * Link title
         */
        title?: string;
        /**
         * Array of link tags
         */
        tags?: Array<string>;
        /**
         * set utm_source parameter to destination link
         */
        utmSource?: string;
        /**
         * set utm_medium parameter to destination link
         */
        utmMedium?: string;
        /**
         * set utm_campaign parameter to destination link
         */
        utmCampaign?: string;
        /**
         * set utm_term parameter to destination link
         */
        utmTerm?: string;
        /**
         * set utm_content parameter to destination link
         */
        utmContent?: string;
        /**
         * Time to live in milliseconds or ISO string
         */
        ttl?: string | number;
        /**
         * Link slug
         */
        path?: string;
        /**
         * Android URL
         */
        androidURL?: string;
        /**
         * iPhone URL
         */
        iphoneURL?: string;
        /**
         * Link creation date in milliseconds
         */
        createdAt?: number | string;
        /**
         * disable link after specified number of clicks
         */
        clicksLimit?: number;
        /**
         * Provide your email to users to get a password
         */
        passwordContact?: boolean;
        /**
         * Skip query string merging
         */
        skipQS?: boolean;
        /**
         * Link is archived
         */
        archived?: boolean;
        /**
         * Split URL
         */
        splitURL?: string;
        /**
         * Split URL percentage
         */
        splitPercent?: number;
        /**
         * Adroll integration
         */
        integrationAdroll?: string;
        /**
         * Facebook integration
         */
        integrationFB?: string;
        /**
         * TikTok integration
         */
        integrationTT?: string;
        /**
         * Google Analytics integration
         */
        integrationGA?: string;
        /**
         * Google Tag Manager integration
         */
        integrationGTM?: string;
    } & {
        /**
         * Link ID
         */
        idString: string;
        /**
         * Link ID
         */
        id: string;
        /**
         * Short URL
         */
        shortURL: string;
        /**
         * Secure short URL
         */
        secureShortURL: string;
        /**
         * Link slug
         */
        path: string;
        /**
         * HTTP code for redirect
         */
        redirectType?: '301' | '302' | '307' | '308';
        /**
         * Folder ID
         */
        FolderId?: string;
        /**
         * Domain ID
         */
        DomainId?: number;
        /**
         * Owner ID
         */
        OwnerId?: number;
        /**
         * Link has password
         */
        hasPassword?: boolean;
        /**
         * Link source
         */
        source?: 'website' | 'api' | 'public' | 'spreadsheets' | 'slack' | 'telegram' | '';
        User?: {
            /**
             * Creator user ID
             */
            id: number;
            /**
             * Creator name
             */
            name: string;
            /**
             * Creator email
             */
            email: string;
            /**
             * User photo URL
             */
            photoURL: string;
        };
    } & {
        success?: boolean;
        duplicate?: boolean;
    } & {
        /**
         * Original link's idString
         */
        duplicatedFrom: string;
    };
};

export type DuplicateLinkResponse = DuplicateLinkResponses[keyof DuplicateLinkResponses];

export type ListDomainsData = {
    body?: never;
    headers?: {
        type?: unknown;
        additionalProperties?: string;
    };
    path?: never;
    query?: {
        limit?: number;
        offset?: number;
        noTeamId?: boolean;
        pattern?: string;
        teamId?: number;
    };
    url: '/api/domains';
};

export type ListDomainsResponses = {
    /**
     * Default Response
     */
    200: Array<{
        /**
         * Domain ID
         */
        id: number;
        hostname: string;
        unicodeHostname: string;
        state: 'extra_records' | 'not_registered' | 'configured' | 'not_configured' | 'registration_pending' | 'not_verified';
        createdAt: string;
        updatedAt: string;
        TeamId?: number;
        hasFavicon: boolean;
        segmentKey?: string;
        hideReferer: boolean;
        linkType: 'increment' | 'random' | 'secure' | 'four-char' | 'eight-char' | 'ten-char';
        /**
         * Enable cloaking for all links on the domain
         */
        cloaking: boolean;
        /**
         * Don't store visitor IPs in our database
         */
        hideVisitorIp: boolean;
        /**
         * Enable AI for all links on the domain
         */
        enableAI: boolean;
        httpsLevel: 'none' | 'redirect' | 'hsts';
        httpsLinks: boolean;
        webhookURL?: string;
        integrationGA?: string;
        integrationFB?: string;
        integrationTT?: string;
        integrationAdroll?: string;
        integrationGTM?: string;
        clientStorage: {
            [key: string]: unknown;
        };
        caseSensitive: boolean;
        incrementCounter: string;
        robots: 'allow' | 'disallow' | 'noindex';
        sslCertExpirationDate?: string;
        sslCertInstalledSuccess?: boolean;
        domainRegistrationId?: number;
        UserId?: number;
        exportEnabled: boolean;
        enableConversionTracking: boolean;
        qrScanTracking: boolean;
        isFavorite: boolean;
    }>;
};

export type ListDomainsResponse = ListDomainsResponses[keyof ListDomainsResponses];

export type GetDomainData = {
    body?: never;
    path: {
        domainId: number;
    };
    query?: never;
    url: '/domains/{domainId}';
};

export type GetDomainErrors = {
    /**
     * Default Response
     */
    403: {
        error: string;
        type?: 'accessDenied';
    };
};

export type GetDomainError = GetDomainErrors[keyof GetDomainErrors];

export type GetDomainResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Domain ID
         */
        id: number;
        hostname: string;
        unicodeHostname: string;
        state: 'extra_records' | 'not_registered' | 'configured' | 'not_configured' | 'registration_pending' | 'not_verified';
        createdAt: string;
        updatedAt: string;
        TeamId?: number;
        hasFavicon: boolean;
        segmentKey?: string;
        hideReferer: boolean;
        linkType: 'increment' | 'random' | 'secure' | 'four-char' | 'eight-char' | 'ten-char';
        /**
         * Enable cloaking for all links on the domain
         */
        cloaking: boolean;
        /**
         * Don't store visitor IPs in our database
         */
        hideVisitorIp: boolean;
        /**
         * Enable AI for all links on the domain
         */
        enableAI: boolean;
        httpsLevel: 'none' | 'redirect' | 'hsts';
        httpsLinks: boolean;
        webhookURL?: string;
        integrationGA?: string;
        integrationFB?: string;
        integrationTT?: string;
        integrationAdroll?: string;
        integrationGTM?: string;
        clientStorage: {
            [key: string]: unknown;
        };
        caseSensitive: boolean;
        incrementCounter: string;
        robots: 'allow' | 'disallow' | 'noindex';
        sslCertExpirationDate?: string;
        sslCertInstalledSuccess?: boolean;
        domainRegistrationId?: number;
        UserId?: number;
        exportEnabled: boolean;
        enableConversionTracking: boolean;
        qrScanTracking: boolean;
    } & {
        ipExclusions: Array<string>;
        userPlan: 'tiny' | 'hobby' | 'small' | 'standard' | 'large';
    };
};

export type GetDomainResponse = GetDomainResponses[keyof GetDomainResponses];

export type UpdateDomainSettingsData = {
    body?: {
        httpsLevel?: 'none' | 'redirect' | 'hsts';
        robots?: 'allow' | 'disallow' | 'noindex';
        segmentKey?: string;
        linkType?: 'increment' | 'random' | 'secure' | 'four-char' | 'eight-char' | 'ten-char';
        /**
         * Enable cloaking for all links on the domain
         */
        cloaking?: boolean;
        hideReferer?: boolean;
        /**
         * Don't store visitor IPs in our database
         */
        hideVisitorIp?: boolean;
        /**
         * Set to null to reissue a certificate
         */
        httpsLinks?: boolean;
        webhookURL?: string | '' | null;
        integrationGA?: string;
        integrationFB?: string;
        integrationTT?: string;
        integrationAdroll?: string;
        enableConversionTracking?: boolean;
        qrScanTracking?: boolean;
        integrationGTM?: string;
        /**
         * For internal use
         */
        clientStorage?: {
            [key: string]: unknown;
        };
        /**
         * [DEPRECATED] do not use
         */
        purgeExpiredLinks?: boolean;
        enableAI?: boolean;
        /**
         * Enable case sensitivity for short links
         */
        caseSensitive?: boolean;
    };
    path: {
        domainId: number;
    };
    query?: never;
    url: '/domains/settings/{domainId}';
};

export type UpdateDomainSettingsErrors = {
    /**
     * Default Response
     */
    400: {
        error: string;
        message?: string;
    };
    /**
     * Default Response
     */
    401: {
        error: string;
    };
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    404: {
        error: string;
    };
};

export type UpdateDomainSettingsError = UpdateDomainSettingsErrors[keyof UpdateDomainSettingsErrors];

export type UpdateDomainSettingsResponses = {
    /**
     * Default Response
     */
    200: {
        success: boolean;
    };
};

export type UpdateDomainSettingsResponse = UpdateDomainSettingsResponses[keyof UpdateDomainSettingsResponses];

export type AddTagsBulkData = {
    body: {
        tag: string;
        link_ids: Array<string>;
    };
    path?: never;
    query?: never;
    url: '/tags/bulk';
};

export type AddTagsBulkResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateDomainData = {
    body: {
        /**
         * Domain hostname
         */
        hostname: string;
        hideReferer?: boolean;
        linkType?: 'increment' | 'random' | 'secure' | 'four-char' | 'eight-char' | 'ten-char';
    };
    path?: never;
    query?: never;
    url: '/domains';
};

export type CreateDomainErrors = {
    /**
     * Default Response
     */
    402: {
        error: string;
    };
    /**
     * Default Response
     */
    403: {
        error: string;
    };
    /**
     * Default Response
     */
    409: {
        error: string;
    };
};

export type CreateDomainError = CreateDomainErrors[keyof CreateDomainErrors];

export type CreateDomainResponses = {
    /**
     * Default Response
     */
    200: {
        /**
         * Domain ID
         */
        id: number;
        hostname: string;
        unicodeHostname: string;
        state: 'extra_records' | 'not_registered' | 'configured' | 'not_configured' | 'registration_pending' | 'not_verified';
        createdAt: string;
        updatedAt: string;
        TeamId?: number;
        hasFavicon: boolean;
        segmentKey?: string;
        hideReferer: boolean;
        linkType: 'increment' | 'random' | 'secure' | 'four-char' | 'eight-char' | 'ten-char';
        /**
         * Enable cloaking for all links on the domain
         */
        cloaking: boolean;
        /**
         * Don't store visitor IPs in our database
         */
        hideVisitorIp: boolean;
        /**
         * Enable AI for all links on the domain
         */
        enableAI: boolean;
        httpsLevel: 'none' | 'redirect' | 'hsts';
        httpsLinks: boolean;
        webhookURL?: string;
        integrationGA?: string;
        integrationFB?: string;
        integrationTT?: string;
        integrationAdroll?: string;
        integrationGTM?: string;
        clientStorage: {
            [key: string]: unknown;
        };
        caseSensitive: boolean;
        incrementCounter: string;
        robots: 'allow' | 'disallow' | 'noindex';
        sslCertExpirationDate?: string;
        sslCertInstalledSuccess?: boolean;
        domainRegistrationId?: number;
        UserId?: number;
        exportEnabled: boolean;
        enableConversionTracking: boolean;
        qrScanTracking: boolean;
    };
};

export type CreateDomainResponse = CreateDomainResponses[keyof CreateDomainResponses];

export type ListFoldersData = {
    body?: never;
    path: {
        domainId: number;
    };
    query?: never;
    url: '/links/folders/{domainId}';
};

export type ListFoldersResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type GetFolderData = {
    body?: never;
    path: {
        domainId: number;
        folderId: string;
    };
    query?: never;
    url: '/links/folders/{domainId}/{folderId}';
};

export type GetFolderResponses = {
    /**
     * Default Response
     */
    200: unknown;
};

export type CreateFolderData = {
    body: {
        domainId: number;
        name: string;
        color?: string;
        backgroundColor?: string;
        logoUrl?: string;
        logoHeight?: number;
        logoWidth?: number;
        ecLevel?: string;
        integrationFB?: string;
        integrationTT?: string;
        integrationGA?: string;
        integrationGTM?: string;
        integrationAdroll?: string;
        utmCampaign?: string;
        utmMedium?: string;
        utmSource?: string;
        utmTerm?: string;
        utmContent?: string;
        redirectType?: number;
        expiresAtDays?: number;
        icon?: string;
        prefix?: string;
    };
    path?: never;
    query?: never;
    url: '/links/folders';
};

export type CreateFolderResponses = {
    /**
     * Default Response
     */
    200: unknown;
};
